import { render, staticRenderFns } from "./TaxStatements.vue?vue&type=template&id=bb34776c&scoped=true&"
import script from "./TaxStatements.vue?vue&type=script&lang=js&"
export * from "./TaxStatements.vue?vue&type=script&lang=js&"
import style0 from "./TaxStatements.vue?vue&type=style&index=0&id=bb34776c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb34776c",
  null
  
)

export default component.exports